
const digest = '58ddb3d075f4bfb77d05e16516b435a71d1df088582500f6460d940498f3e647';
const classes = {"wrapper":"_wrapper_82sax_1","title":"_title_82sax_6","subtitle":"_subtitle_82sax_11","list":"_list_82sax_16"};
const css = `._wrapper_82sax_1 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_82sax_1 ._title_82sax_6 {
  text-align: center;
  font-size: 32px;
  font-weight: 600;
}
._wrapper_82sax_1 ._subtitle_82sax_11 {
  color: #424754;
  font-size: 18px;
  text-align: center;
}
._wrapper_82sax_1 ._list_82sax_16 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  